import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

import { requiredWhenPresent } from '../../shared/propTypes';
import Modal from '../../shared/modals/modal.component';
import { PeriodPropTypes } from '../../shared/propTypes/period';

import obligationPropTypes from './obligation.propTypes';
import { LookUpDataPropTypes, ObligationPropTypes } from './propTypes';
import { shouldWarnAboutClearingBSMBalances } from './validators';

const DeleteObligationModal = ({
  period,
  entityToRemove,
  hideModal,
  removeEntity,
  rowIndex,
  isVisible,
  clearRangeSelection,
  lookUpData,
  obligations,
}) => {
  const removeObligation = useCallback(() => {
    removeEntity({ ...entityToRemove, periodName: period.name }, { rowIndex, clearRangeSelection });
  }, [removeEntity, entityToRemove, period, rowIndex, clearRangeSelection]);

  const warnAboutBSMBalances = useMemo(() =>
    entityToRemove && shouldWarnAboutClearingBSMBalances(
      entityToRemove, lookUpData, obligations, { isBeingRemoved: true }
    ),
  [entityToRemove, lookUpData, obligations]
  );

  return (
    <Modal
      className="delete-obligations-modal"
      dismissText="Cancel"
      submitText="Yes"
      title="Delete Obligation"
      closeAction={hideModal}
      dismissAction={hideModal}
      submitAction={removeObligation}
      isVisible={isVisible}
    >
      {
        entityToRemove
          ? (
            <>
              <div>
                Are you sure you want to delete: <br/>
                Company Code: {entityToRemove.companyCode} <br/>
                Country Code: {entityToRemove.countryCode} <br/>
                Country Tax Type: {entityToRemove.countryTaxType} <br/>
                Description: {entityToRemove.countryTaxTypeDescription}
              </div>
              {
                warnAboutBSMBalances
                  ? (
                    <div className="mt-2">
                      Warning! You are removing obligations for a BSM enabled company code.
                      This may orphan balances.
                      Only click &quot;Yes&quot; if you confirm there are no existing BSM Balances,
                      or they have been cleared.
                    </div>
                  )
                  : null
              }
            </>
          )
          : null
      }
    </Modal>
  );
};

DeleteObligationModal.propTypes = {
  period: PeriodPropTypes.isRequired,
  entityToRemove: requiredWhenPresent(['isVisible'], obligationPropTypes),
  hideModal: PropTypes.func.isRequired,
  removeEntity: PropTypes.func.isRequired,
  rowIndex: requiredWhenPresent(['isVisible'], PropTypes.number),
  isVisible: PropTypes.bool,
  clearRangeSelection: PropTypes.func,
  obligations: PropTypes.arrayOf(ObligationPropTypes).isRequired,
  lookUpData: LookUpDataPropTypes.isRequired,
};

export default DeleteObligationModal;
